import React from 'react';
import styles from '../DonationForm.module.css';

// The one-time donation amount input + $25/$50/$100/$200/$500/$1000
// quick-shortcut buttons. Extracted VERBATIM from
// DonationAmountSection's render.
export default function OneTimeAmountFields({
  clientSecret, onClientSecretChange, oneTimeAmount, paymentIntentCreatedRef,
  preservedOneTimeAmount, setClientSecret, setOneTimeAmount, setPaymentIntentId,
  setPreservedOneTimeAmount, setShowPaymentElement, setShowPaymentForm, showPaymentElement,
  showPaymentForm,
}) {
  return (
    <div>
      <input
        className={styles.input}
        type="text"
        inputMode="decimal"
        id="oneTimeAmount"
        placeholder="$0.00"
        onBlur={(e) => {
          const raw = e.target.value.replace(/[^0-9.]/g, '');
          const val = parseFloat(raw);
          if (!isNaN(val) && val > 0) {
            const formatted = val.toFixed(2);
            setOneTimeAmount(formatted);
            if (preservedOneTimeAmount) {
              setPreservedOneTimeAmount(parseFloat(formatted));
            }
          }
        }}
        value={oneTimeAmount ? `$${oneTimeAmount}` : (preservedOneTimeAmount ? `$${parseFloat(preservedOneTimeAmount).toFixed(2)}` : '')}
        onChange={(e) => {
          // Strip $ and non-numeric chars (keep one decimal)
          let val = e.target.value.replace(/[^0-9.]/g, '');
          const parts = val.split('.');
          if (parts.length > 2) val = parts[0] + '.' + parts.slice(1).join('');
          if (parts[1] && parts[1].length > 2) val = parts[0] + '.' + parts[1].substring(0, 2);
          setOneTimeAmount(val);

          // Clear preserved amount when user manually changes the input
          if (preservedOneTimeAmount) {
            const newAmount = parseFloat(val);
            const preservedAmount = parseFloat(preservedOneTimeAmount);
            if (isNaN(newAmount) || Math.abs(newAmount - preservedAmount) > 0.01) {
              setPreservedOneTimeAmount(null);
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              if (onClientSecretChange) {
                onClientSecretChange(null);
              }
            }
          }
        }}
        required
      />
      <div className={styles.quickShortcuts}>
        <button
          className={styles.shortcutButton}
          type="button"
          onClick={() => {
            const newAmount = 25;
            const newAmountStr = '25.00';
            // Always set both form value and preserved value
            setOneTimeAmount(newAmountStr);
            // Update preserved amount to new value (don't clear it)
            setPreservedOneTimeAmount(newAmount);
            // Clear payment intent if amount changed to trigger recreation
            if (!preservedOneTimeAmount || Math.abs(preservedOneTimeAmount - newAmount) > 0.01) {
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              if (onClientSecretChange) {
                onClientSecretChange(null);
              }
            }
          }}
        >
          $25
        </button>
        <button
          className={styles.shortcutButton}
          type="button"
          onClick={() => {
            const newAmount = 50;
            const newAmountStr = '50.00';
            // Always set both form value and preserved value
            setOneTimeAmount(newAmountStr);
            // Update preserved amount to new value (don't clear it)
            setPreservedOneTimeAmount(newAmount);
            // Clear payment intent if amount changed to trigger recreation
            if (!preservedOneTimeAmount || Math.abs(preservedOneTimeAmount - newAmount) > 0.01) {
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              if (onClientSecretChange) {
                onClientSecretChange(null);
              }
            }
          }}
        >
          $50
        </button>
        <button
          className={styles.shortcutButton}
          type="button"
          onClick={() => {
            const newAmount = 100;
            const newAmountStr = '100.00';
            // Always set both form value and preserved value
            setOneTimeAmount(newAmountStr);
            // Update preserved amount to new value (don't clear it)
            setPreservedOneTimeAmount(newAmount);
            // Clear payment intent if amount changed to trigger recreation
            if (!preservedOneTimeAmount || Math.abs(preservedOneTimeAmount - newAmount) > 0.01) {
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              if (onClientSecretChange) {
                onClientSecretChange(null);
              }
            }
          }}
        >
          $100
        </button>
        <button
          className={styles.shortcutButton}
          type="button"
          onClick={() => {
            const newAmount = 200;
            const newAmountStr = '200.00';
            // Always set both form value and preserved value
            setOneTimeAmount(newAmountStr);
            // Update preserved amount to new value (don't clear it)
            setPreservedOneTimeAmount(newAmount);
            // Clear payment intent if amount changed to trigger recreation
            if (!preservedOneTimeAmount || Math.abs(preservedOneTimeAmount - newAmount) > 0.01) {
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              if (onClientSecretChange) {
                onClientSecretChange(null);
              }
            }
          }}
        >
          $200
        </button>
        <button
          className={styles.shortcutButton}
          type="button"
          onClick={() => {
            const newAmount = 500;
            const newAmountStr = '500.00';
            // Always set both form value and preserved value
            setOneTimeAmount(newAmountStr);
            // Update preserved amount to new value (don't clear it)
            setPreservedOneTimeAmount(newAmount);
            // Clear payment intent if amount changed to trigger recreation
            if (!preservedOneTimeAmount || Math.abs(preservedOneTimeAmount - newAmount) > 0.01) {
              setClientSecret(null);
              setShowPaymentElement(false);
              setShowPaymentForm(false);
              setPaymentIntentId(null);
              paymentIntentCreatedRef.current = false;
              if (onClientSecretChange) {
                onClientSecretChange(null);
              }
            }
          }}
        >
          $500
        </button>
        <button
          className={styles.shortcutButton}
          type="button"
          onClick={() => {
            if (!(showPaymentElement && !!clientSecret)) {
              setOneTimeAmount('1000.00');
              setPreservedOneTimeAmount(1000);
            }
          }}
          disabled={showPaymentForm && !!clientSecret}
        >
          $1000
        </button>
      </div>
    </div>
  );
}
